<i18n src="../../../lang/actions.json" />
<i18n>
  {
  "en": {
  "amo_info": "AMO Info",
  "load_service_info_from_amo": "Load from Amo",
  "delete_from_amo": "Delete from Amo",
  "confirm_delete": "I'm in of my mind"
  },
  "ua": {
  "amo_info": "AMO Info",
  "load_service_info_from_amo": "Load from Amo",
  "delete_from_amo": "Delete from Amo",
  "confirm_delete": "Я в своем уме"
  },
  "ru": {
  "amo_info": "AMO Info",
  "load_service_info_from_amo": "Load from Amo",
  "delete_from_amo": "Delete from Amo",
  "confirm_delete": "Я при своему розумі"
  }
  }
</i18n>
<template>
  <div class="service-info">
    <el-image
      class="widget-image"
      :src="service.image"
      fit="cover"
      :lazy="false"
    />
    <template
      v-if="
        service.isWidget &&
          service.hasValidIntegration &&
          service._embedded.sharedAmocrm &&
          service._embedded.sharedAmocrm.password
      "
    >
      <template v-if="false">
        <section-divider
          :text="$t('amo_info')"
          class="service-info__section-devider"
        />
        <el-row>
          <el-col v-if="!info_from_amo">
            <el-row type="flex" justify="center">
              <el-button
                size="small"
                v-text="$t('load_service_info_from_amo')"
                @click.once="handleLoadServiceInfoFromAmo"
              />
            </el-row>
          </el-col>
          <template v-else>
            <template v-for="w in info_from_amo">
              <el-row
                :key="w.id"
                :class="{ 'bordered-info-block': info_from_amo.length > 1 }"
              >
                <div class="service-info__amo">
                  <span class="service-info__amo--label">id</span>
                  <span
                    v-text="w.id"
                    class="service-info__amo--value"
                    @mouseenter.once="showTooltip"
                  />
                </div>
                <div class="service-info__amo">
                  <span class="service-info__amo--label">code</span>
                  <span
                    v-text="w.code"
                    class="service-info__amo--value"
                    @mouseenter.once="showTooltip"
                  />
                </div>
                <div class="service-info__amo">
                  <span class="service-info__amo--label">version</span>
                  <span
                    v-text="w.version"
                    class="service-info__amo--value"
                    @mouseenter.once="showTooltip"
                  />
                </div>
                <el-card class="service-info__amo--card">
                  <div
                    slot="header"
                    class="clearfix service-info__amo--card-header"
                  >
                    <span
                      v-text="'Settings'"
                      class="service-info__amo--card-header--text"
                    />
                    <el-icon
                      :style="{
                        color: w.active ? 'green' : 'grey',
                        opacity: w.active ? 1 : 0.1
                      }"
                      name="check"
                      class="service-info__amo--card-header--icon"
                    />
                  </div>
                  <div
                    v-for="v in Object.keys(w.settings).filter(
                      f => f !== 'active'
                    )"
                    class="service-info__amo"
                    :key="v"
                  >
                    <span class="service-info__amo--label" v-text="v" />
                    <span
                      v-text="w.settings[v]"
                      class="service-info__amo--value"
                      @mouseenter.once="showTooltip"
                    />
                  </div>
                </el-card>
              </el-row>
              <el-row
                :key="'s' + w.id"
                v-if="info_from_amo.length === 1"
                type="flex"
                justify="end"
                style="margin-top: 20px"
              >
                <el-popconfirm
                  :title="$t('confirm_delete')"
                  :confirmButtonText="$t('actions.delete')"
                  :cancelButtonText="$t('actions.cancel')"
                  @onConfirm="handleDeleteWidgetFromAMO"
                >
                  <el-button
                    slot="reference"
                    type="danger"
                    size="small"
                    v-text="$t('delete_from_amo')"
                  />
                </el-popconfirm>
              </el-row>
            </template>
          </template>
        </el-row>
      </template>

      <section-divider class="service-info__section-devider" />
      <el-row type="flex" justify="center">
        <el-button
          size="small"
          v-text="btnUpdateCaption"
          :type="btnUpdateType"
          :disabled="btnUpdateDisabled"
          @click="
            service._embedded.sharedWidgets
              // .installFor(
              .installForAsIntegration(
                service._embedded.sharedCustomers,
                service._embedded.sharedAmocrm
              )
              .catch(() => {})
              .then(() => {
                info_from_amo = undefined;
              })
          "
        />
      </el-row>
      <section-divider class="service-info__section-devider" />
    </template>
  </div>
</template>

<script>
import SectionDivider from "./SectionDivider";

export default {
  name: "ServiceDetailsElement",
  components: { SectionDivider },
  props: {
    service: Object
  },
  data: () => ({
    info_from_amo: undefined,
    achtung: false
  }),
  methods: {
    showTooltip(...args) {
      let el = args[0].target;
      if (el.offsetWidth < el.scrollWidth && !el.getAttribute("title")) {
        el.setAttribute("title", el.innerText);
      }
    },
    async handleLoadServiceInfoFromAmo() {
      this.info_from_amo = await this.service.loadServiceInfoFromAmo();
      this.info_from_amo.length < 2 || (this.achtung = true);
    },
    async handleDeleteWidgetFromAMO() {
      let res = await this.service.deleteWidgetInAMO();
      if (res) {
        this.info_from_amo = undefined;
        this.achtung = false;
      }
    }
  },
  computed: {
    btnUpdateCaption() {
      return this.info_from_amo === undefined
        ? this.$t("actions.force_update")
        : this.info_from_amo.length === 0
        ? this.$t("actions.install")
        : this.$t("actions.update");
    },
    btnUpdateType() {
      return this.info_from_amo ? "primary" : "warning";
    },
    btnUpdateDisabled() {
      if (this.info_from_amo === undefined) {
        return false;
      }
      return this.info_from_amo && this.info_from_amo.length > 1;
    }
  }
};
</script>

<style lang="stylus">
.service-info
  &__section-devider
    & .el-divider__text
      background-color #f0f0f0
</style>
<style scoped lang="stylus">
.bordered-info-block
  border 2px dotted lightgray
  padding 0 5px 10px

  &:not(:last-child)
    margin-bottom 10px

  &:hover
    box-shadow 0 0 4px 0 #f56c6c

.service-info__amo
  margin 20px 0

  & > span
    display block

  & &--label
    background-color #666666
    background-clip text
    color transparent
    text-shadow rgba(255, 255, 255, 0.5) 0px 3px 3px

    &after
      content ""

  & &--value
    text-align end
    text-overflow ellipsis
    overflow hidden
    height 1.2em
    white-space nowrap
    border 2px dashed lightgray

  &--card
    &-header
      text-shadow 1px 1px 2px #6e6e6e

      &--text
        letter-spacing 5px

      /* font-weight bold */

      &--icon
        float right
        font-weight bold
        font-size 1.5em
</style>
